export const ARCHIMAGE_LOGO_VERSION = '20260711-7';

export function getArchimageLogoUrl() {
  const base = process.env.PUBLIC_URL || '';
  return `${base}/archimage-logo.png?v=${ARCHIMAGE_LOGO_VERSION}`;
}

export function getArchimageLogoAbsoluteUrl() {
  if (typeof window === 'undefined') return getArchimageLogoUrl();
  return `${window.location.origin}${getArchimageLogoUrl()}`;
}
